/**
 *
 * Asynchronously loads the component for Prodotto
 *
 */

import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./index'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./app/containers/Prodotti/Loadable.js